import type { LocalBufferPort } from '@Domain/Ports/LocalBuffer/LocalBufferPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useLocalBufferPort(): LocalBufferPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useLocalBufferPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.localBuffer;
}

export default useLocalBufferPort;
